import { useTranslation } from 'next-i18next';
import { LinkedPerson } from '../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { ConditionalWrapper } from '../../../../common/ConditionalWrapper';
import VyTooltip from '../../../../common/VyTooltip';
import AttendeeAvatar from '../AttendeeAvatar';

interface BoothLinkedPersonInterface {
  person: LinkedPerson;
  onLinkedPersonClick: (user: LinkedPerson['user']) => void;
}

const BoothLinkedPerson = ({ person, onLinkedPersonClick }: BoothLinkedPersonInterface) => {
  const { t } = useTranslation();
  const user = useSelector(({ common }) => common.user);
  return (
    <ConditionalWrapper
      condition={user?._id !== person.user._id}
      wrapper={(children) => <VyTooltip title={t('event:chat-with-exhibitor', { name: person.name })}>{children}</VyTooltip>}>
      <div
        className={`w-full px-2 py-1 rounded flex flex-row items-center space-x-4 bg-slate-100 ${
          user?._id !== person.user._id ? 'shadow-none hover:shadow-md hover:bg-slate-200 cursor-pointer transition-all' : ''
        }`}
        onClick={() => user?._id !== person.user._id && onLinkedPersonClick(person.user)}>
        <AttendeeAvatar attendee={{ ...person.user, avatar: person.avatar }} clickable={false} showStatus />
        <div className="flex flex-col justify-start h-full">
          <b>{person.name}</b>
          <p>{person.description}</p>
        </div>
      </div>
    </ConditionalWrapper>
  );
};
export default BoothLinkedPerson;
